
import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { Global } from 'src/app/Service/global.service';
import { StatiquePageService } from '../../Service/statique-page.service';
import { SharedService } from 'src/app/Service/shared.service';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import * as xml2js from 'xml2js';
declare var $: any;
@Component({
  selector: 'app-securite-portuaire',
  templateUrl: './securite-portuaire.component.html',
  styleUrls: ['./securite-portuaire.component.scss']
})
export class SecuritePortuaireComponent implements OnInit  {
  panelOpenState = false;
  constructor(private global: Global,  private shared: SharedService, private service: StatiquePageService, private router: Router) {
    
   }
  bloc = {
    Titre: "",
    Contenu: ""
  }
  icons =[]
  AccourdionFixer(){
    var checkExist = setInterval(function() {
      if (document.getElementsByClassName('faq').length > 0) {
          
          if (document.getElementsByClassName('rtl').length > 0) {  
            clearInterval(checkExist); 
          const icons = Array.from(document.getElementsByClassName('rotate-icon') as HTMLCollectionOf<HTMLElement>);
          icons.forEach((element) => {
            element['style'].float = "left";
            element['style'].paddingLeft = "20px";
          });  
          const titles = Array.from(document.querySelectorAll('.questionFaq a'));
          titles.forEach((element) => {
            element['style'].paddingLeft = "0px"; 
            element['style'].paddingRight = "20px"; 
          }); 
        }  
    }
   }, 100); // check every 100ms
  }
  ngOnInit(): void {
    
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {      
      this.shared.getBlocDescriptionByCode(lg.url, "Securiteportuaire").subscribe(data => {
        const p: xml2js.Parser = new xml2js.Parser();
        this.bloc.Titre = data["value"][0] ? data["value"][0].Title : "";
        this.bloc.Contenu = data["value"][0] ? data["value"][0].Contenu : "";
      })
      this.service.getPageByName("Securiteportuaire", lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          const url = this.global._baseUrlRacine + encodeURIComponent(datas['value'][0].File.ServerRelativeUrl);
          // Replace with 
          //const url = this.global._basedUrl + datas['value'][0].File.ServerRelativeUrl;
          $('#securiteportuaire').load(url,()=>{
            this.AccourdionFixer();
            $('#securiteportuaire style').remove();
          });
        } else {
          this.router.navigate(['/']);
        }
      });
    })
  }

}
